import { createEvent, createStore } from '@cobuildlab/react-simple-state';
import {
  MetatraderAccount,
  MetatraderSymbolSpecification,
  MetatraderSymbolPrice,
} from 'metaapi.cloud-sdk';
import { AxiosError } from 'axios';
import {
  MetaApiCloudAccount,
  MetaStatMetric,
  MetaStatTradesMetric,
} from './meta-api-cloud-types';
import { META_STAT_TRADES } from './meta-api-cloud-constants';

export const createMetaApiAccountEvent = createEvent<{
  account: MetaApiCloudAccount | undefined;
}>({
  initialValue: undefined,
});

export const createMetaApiAccountErrorEvent =
  createEvent<AxiosError<{ message: string }>>();

export const updateMetaApiAccountEvent = createEvent<{
  account: MetaApiCloudAccount;
}>({
  initialValue: undefined,
});

export const updateMetaApiAccountErrorEvent =
  createEvent<AxiosError<{ message: string }>>();

export const updateMetaApiBrokerEvent = createEvent<{
  account: MetatraderAccount | undefined;
}>({
  initialValue: undefined,
});

export const updateMetaApiBrokerErrorEvent =
  createEvent<AxiosError<{ message: string }>>();

export const fetchSymbolSpecificationStore = createStore<{
  symbolSpecifications: Array<MetatraderSymbolSpecification>;
}>({
  initialValue: {
    symbolSpecifications: [],
  },
});

export const fetchSymbolPriceStore = createStore<{
  price: MetatraderSymbolPrice | undefined;
}>({
  initialValue: {
    price: undefined,
  },
});

export const fetchMetaStatTradesMetricEvent = createEvent<MetaStatTradesMetric>({
  initialValue:META_STAT_TRADES,
});

export const fetchMetaStatTradesErrorMetricEvent = createEvent<Error>();

export const fetchMetaStatMetricsEvent = createEvent<{
  metrics: MetaStatMetric | undefined;
}>({
  initialValue: {
    metrics: undefined,
  },
});

export const fetchMetaStatMetricsErrorEvent = createEvent();
